module.exports = __webpack_public_path__ + "static/media/BenChung.11780f6d.jpeg";